module.exports = __webpack_public_path__ + "img/caiwu.1930de1b.png";